<template>
  <tr>
    <!-- 置顶 -->
    <td
      :style="`visibility:${message.isTop ? 'visiable' : 'hidden'}`"
      class="top"
    />
    <!-- 图标 -->
    <td
      :style="`background-image:url(${stringToIcon(message.department)})`"
      class="icon"
    />
    <!-- 标题 -->
    <td class="title">
      <!-- 当文字长度大于19个时(出现省略号),有popover提示框 -->
      <ElPopover
        v-model="state"
        v-if="message.title.length > 19"
        placement="bottom-start"
        width="390"
        trigger="hover"
        transition=""
        :content="message.title"
        :open-delay="1000"
      >
        <a
          slot="reference"
          class="content"
          @mousewheel="state=false"
          :class="[message.isRead ? 'read-color' : 'unread-color']"
          :href="message.link"
        >
          {{ message.title }}
        </a>
      </ElPopover>
      <!-- 没有出现省略号,就不出现提示框 -->
      <a
        v-else
        slot="reference"
        class="content"
        :class="[message.isRead ? 'read-color' : 'unread-color']"
        :href="message.link"
      >
        {{ message.title }}
      </a>
    </td>
    <!-- 时间 -->
    <td class="time">
      {{ message.time | formatTime }}
    </td>
  </tr>
</template>

<script>
import ad from '@/assets/department/ad_icon@2x.png';
import ceo from '@/assets/department/ceo_icon@2x.png';
import edu from '@/assets/department/edu_icon@2x.png';
import er from '@/assets/department/er_icon@2x.png';
import fd from '@/assets/department/fd_icon@2x.png';
import hr from '@/assets/department/hr_icon@2x.png';
import it from '@/assets/department/it_icon@2x.png';
import { formatTime } from '@/utils/time';


const icons = {
  ad,
  ceo,
  edu,
  er,
  fd,
  hr,
  it,
};
export default {
  data() {
    return {
      state: false,
    };
  },
  filters: {
    formatTime: time => formatTime(new Date(time)),
  },
  props: {
    message: {
      type: Object,
      default: () => ({
        department: ad,
        title: '默认消息!',
        time: '00:00',
        link: 'https://baidu.com',
      }),
    },
  },
  methods: {
    stringToIcon(str) {
      return icons[str] ? icons[str] : ad;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/message.scss";
tr {
  .top {
    display: inline-block;
    height: 36px;
    width: 20px;
    margin-left: -20px;
    background-image: url("../../../assets/home/top@2x.png");
    background-size: 10px 12px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .icon {
    width: 8%;
    height: 100%;
    background-size: 24px 16px;
    background-repeat: no-repeat;
    background-position: left;
  }
  .title {
    width: 82%;
  }
}
</style>
